/**
 * This is the twofaProductAppController.
 * @memberOf twofa Module
 * @namespace twofaProductAppController
 */

/**
 * @name twofaProductAppController
 * @desc Create the controller.
 * @param $scope
 * @param $translate
 * @param coreService
 * @param $log
 * @param $state
 * @param $window
 * @memberOf twofa Module.twofa Controller
 * @ngInject
 */
function twofaProductAppController($scope, $translate, coreService, $log, $state, $window) {
    // Assign this controller as the view-model.
    // It will be accessible as 'twofaProductAppController' within the HTML template.
    
    var vm = this;
  
    //properties
    vm.passCode = '';
    vm.has_errors = false;
    vm.errorMessage= '';
    vm.twoFactorAuthenticationType = '';
    vm.has_errors = false;
    vm.androidAppDownloadUrl = '';
    vm.iosAppDownloadUrl = '';
    vm.androidAppStoreImgUrl = '';
    vm.iosAppStoreImgUrl = '';
    vm.productAppDisplayName = '';
    vm.getSsoQrCodeImgSrc = getSsoQrCodeImgSrc;

    // Activate the controller.
    activate();
  
    // Activates the controller.
    function activate() {
  
        // Read Identity Server's data model
        var model = coreService.getIdentityModel();
        if(model == null || typeof(model.data) === 'undefined'){
            $state.go('error');
        }

        $scope.model = model;
        vm.has_errors = $scope.model.has_errors;
        vm.twofactorsection = "twofasection twofasection-wider";
        vm.errorMessage = $scope.model.errorMessage;
        vm.twoFactorAuthenticationType = $scope.model.two_factor_auth_type;
        vm.twofactorselections =  $scope.model.two_factor_selections;
        
        if($scope.model.data != null){    
            if($scope.model.data.androidAppDownloadUrl != null && typeof($scope.model.data.androidAppDownloadUrl) !== 'undefined'){
                vm.androidAppDownloadUrl = $scope.model.data.androidAppDownloadUrl;
            }
    
            if($scope.model.data.iosAppDownloadUrl != null && typeof($scope.model.data.iosAppDownloadUrl) !== 'undefined'){
                vm.iosAppDownloadUrl = $scope.model.data.iosAppDownloadUrl;
            }
    
            if($scope.model.data.productAppDisplayName != null && typeof($scope.model.data.productAppDisplayName) !== 'undefined'){
                vm.productAppDisplayName = $scope.model.data.productAppDisplayName;
            }

            if($scope.model.data.ssoQrCode != null && typeof($scope.model.data.ssoQrCode) !== 'undefined'){
                vm.SsoQrCode = $scope.model.data.ssoQrCode;
            }
        }

        vm.androidAppStoreImgUrl = buildGoogleAppStoreImgUrl();
        vm.iosAppStoreImgUrl = buildAppleAppStoreImgUrl();

        let stateCheck = setInterval(() => {
            if ($window.document.readyState === 'complete') {
              clearInterval(stateCheck);
              vm.isPageLoadComplete = true;
              
              $translate(['twofa.registration.form.done_button', 'twofa.registration.form.intro_text_fraedom_app2', 
                          'twofa.registration.form.intro_text_sso_fraedom_app2', 'twofa.registration.form.qrcode_tooltip', 
                          'twofa.registration.authenticatorapps.applestorebadge_tooltip', 
                          'twofa.registration.authenticatorapps.googlestorebadge_tooltip',
                          'twofa.registration.form.intro_text_sso_fraedom_app1',
                          'twofa.registration.form.intro_text_fraedom_app1',
                          'twofa.registration.form.header'], { productAppName: vm.productAppDisplayName }) 
              .then(function(data) {
                  vm.data = data; 
                  if(vm.has_errors)
                  {
                    setAriaLabelOnLoad(false, 'btnVerify');
                  }
                  else
                  {
                    setAriaLabelOnLoad(true, 'btnVerify');
                  }                  
                  setFocus("btnVerify");   
              });          
            }
        }, 0); 
    }       
    
    function setFocus(id)
    {      
      var element = $window.document.getElementById(id);
      if(typeof(element) != 'undefined' && element != null)
      {
        $window.setTimeout(function(){ element.focus(); }, 0);
      }      
    }

    function setAriaLabelOnLoad(enable, id)
    {
        var element = document.getElementById(id);

        if(typeof(element) != 'undefined' && element != null)
        {
            var arialDescriptionText = vm.data['twofa.registration.form.done_button'];

            if (enable)
            {
                if(!vm.SsoQrCode)
                {
                    arialDescriptionText = vm.data['twofa.registration.form.header'] + '. ' 
                    + vm.data['twofa.registration.form.intro_text_fraedom_app1'] 
                    + vm.data['twofa.registration.form.intro_text_fraedom_app2'] 
                    + vm.data['twofa.registration.form.done_button'];    
                }
                else
                {
                    arialDescriptionText = vm.data['twofa.registration.form.header'] + '. ' 
                    + vm.data['twofa.registration.form.intro_text_sso_fraedom_app1']
                    + vm.data['twofa.registration.form.intro_text_sso_fraedom_app2']
                    + vm.data['twofa.registration.form.done_button']; 
                }
            }
            
            element.setAttribute('aria-label', arialDescriptionText);
        }
    }

    function buildGoogleAppStoreImgUrl() {
      return 'images/google/' + getlocales() + '/play-badge.png';
    }
  
    function buildAppleAppStoreImgUrl() {
      return 'images/apple/' + getlocales() + '/Download_on_the_App_Store_Badge_135x40.svg';
    }
        
    function getlocales(){
        if($scope.model.ui_locales === 'en-us' || $scope.model.ui_locales === 'en-gb'){
        return 'en';
        }

        return $scope.model.ui_locales;
    }

    function getSsoQrCodeImgSrc() {
        return "data:image/JPEG;base64," + vm.SsoQrCode;
    }
}
  
export default twofaProductAppController;


// WEBPACK FOOTER //
// ./src/login/2fa/productapp/2fa.productapp.controller.js